import {
    Checkbox,
    LABEL_PLACEMENT,
    STYLE_TYPE
} from "baseui/checkbox";
import { Slider } from "baseui/slider";
import { FormControl } from 'baseui/form-control';
import { Block } from "baseui/block";
import { FormattedMessage } from "react-intl";

export interface LimitProps {
    name: any;
    value: number;
    dimension: string;
    min: number;
    max: number;
    enable: boolean;
    onEnableChanged: any;
    onValueChanged: any;
}

export const Limit = (props: LimitProps) => {

    const min = Math.min(props.min ?? 0, props.value);
    const max = Math.max(props.max ?? 100, props.value);
    
    const disable = !props.enable;
    return (
        <>

            <FormControl label={() => props.name} caption={<FormattedMessage id="Limit.Caption" defaultMessage="Select a limit to trigger an alarm" />}>
                <Block display='flex' flexDirection='row' gridRowGap='65px'  >
                <Checkbox
                    checked={props.enable}
                    checkmarkType={STYLE_TYPE.toggle_round}
                    onChange={(e: any) => { props.onEnableChanged(e.target.checked) }}>
                    <FormattedMessage id="Limit.Enable" defaultMessage="Enable" />
                </Checkbox>

                <Slider 
                    min={min}
                    max={max}
                    disabled={disable}
                    onChange={({ value }) => props.onValueChanged(value)}
                    step={0.5}
                    persistentThumb={props.enable}
                    value={[props.value]}
                    valueToLabel={(value) => `${value} ${props.dimension}`}
                ></Slider>
                </Block>
            </FormControl>
        </>
    )
}
